<template>
    <div class='advanced-page container main-content'>
        <div class='filters-list'>
            <div class='row'>
                <div class='col-md-12'>
                    <h3>Advanced Search</h3>
                </div>
            </div>
            <div class='row clause-warning' v-show='clauses.length == limit'>
                <p class='col-md-12 text-danger'>
                    Advanced Search is limited to {{limit}} clauses
                </p>
            </div>

            <!-- Which catalog to search in -->
            <div class='row'>
                <div class='col-md-4'>
                    <div class='search-in'>
                        <label for='catalog'>
                            <strong>Search in</strong>
                        </label>
                        <select id='catalog' class='form-control' v-model='catalog'>
                            <option value=''>All Records</option>
                            <option value='Archives'>Archives</option>
                            <option value='Collections'>Collections</option>
                            <option value='Collections NOAA'>Collections NOAA</option>
                            <option value='Library'>Library</option>
                        </select>
                    </div>
                </div>
                <div class='col-md-8'></div>
            </div>

            <!-- list of Clauses -->
            <div v-for='(row, index) in clauses'>
                <div class='row'>
                    <!-- First Row -->
                    <div class='col-md-4 select-wrapper'>
                            <select v-show='index != 0' class='form-control bool-clause' v-model='row.bool'>
                                <option value='and'>and</option>
                                <option value='or'>or</option>
                            </select>
                        <!-- <div "> -->
                            <select :class="{'first-property': index == 0, 'property': index != 0}" class='form-control' v-model='row.field'>
                                <option value=''>Select...</option>
                                <option v-bind:value='option' v-for='option in field_options'>
                                    {{option.name}}
                                </option>
                            </select>
                    </div>
                    <div class='col-md-8  manage-clauses'>
                        <input type="text" name="keywords" v-model.trim='row.text' class='form-control'>
                        <span class='btn-wrapper'>
                            <button type='button' class='add' @click='addRow(index)'></button>
                            <button type='button' class='remove' @click='removeRow(index)'></button>
                        </span>
                    </div>
                </div>
            </div>

            <!-- Date -->
            <div class='row date-container'>
                <div class='hidden-sm hidden-xs col-md-3'></div>
                <div class='col-xs-2 col-md-1 date-label'>
                    <strong>Date</strong>
                </div>
                <div class='col-xs-10 col-md-4 from'>
                    <label for='from_year'>From</label>
                    <input class='form-control' v-model='from.year' type='text' id='from_year' placeholder='Year' @change.lazy='setYear(true)'>
                    <select class='form-control' v-model='from.era'>
                        <option value='AD/CE'>AD/CE</option>
                        <option value='BC/BCE'>BC/BCE</option>
                        <option value='BP'>BP</option>
                    </select>
                </div>
                <div class='visible-sm-inline visible-xs-inline col-xs-2'></div>
                <div class='col-xs-10 col-md-4 to'>
                    <label for='to_year'>To</label>
                    <input class='form-control' v-model='to.year' type='text' id='to_year' placeholder='Year' @change.lazy='setYear(false)'>
                    <select class='form-control' v-model='to.era'>
                        <option value='AD/CE'>AD/CE</option>
                        <option value='BC/BCE'>BC/BCE</option>
                        <option value='BP'>BP</option>
                    </select>
                </div>
            </div>
            <div class='row form-buttons'>
                <div class='col-xs-12'>
                    <div class='col-xs-12'>
                        <button type='button' class='pull-right btn bg-white' @click='clear'>Clear</button>
                        <button type='button' class='pull-right btn bg-lime-green' @click='search'>Search</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dateFilter from './../mixins/dateFilter.js'
    import FilterManager from './filterManager.js'

    export default {
        mixins: [dateFilter],
        data: function () {
            return {
                limit: 5,
                from: this.resetYear(),
                to: this.resetYear(),
                catalog: '',
                clauses: this.resetClause(),
                field_options: [
                    {name: 'Creator/Author', field: 'searchable-actors'},
                    {name: 'Exhibit', field: 'searchable-exhibits'},
                    {name: 'Genre', field: 'searchable-genre'},
                    {name: 'Language', field: 'searchable-languages'},
                    {name: 'Material', field: 'searchable-materials'},
                    {name: 'Place', field: 'searchable-places'},
                    {name: 'Title', field: 'searchable-title'},
                    {name: 'Topic/Term', field: 'searchable-topics'},
                    {name: 'Object', field: 'searchable-types'},
                    {name: 'Vessel', field: 'searchable-vessels'},
                ]
            }
        },
        created: function () {
            ga('set', 'page', '/advanced')
            ga('send', 'pageview')

            window.document.title = "Advanced Search - The Mariners' Museum Online Catalog"
            var description = "At The Mariners' Museum, explore over 60,000 square feet of gallery space with rare figureheads, handcrafted ship models, Civil War ironclad USS Monitor artifacts, paintings, and much more."
            $('meta[name=description]').attr('content', description)
            window.document.description = description

            // this.$ua.trackView('/advanced')
        },
        methods: {
            setYear: function (from = false) {
                if (from) {
                    this.to.year = this.to.year ? this.to.year : this.from.year
                    return
                }

                this.from.year = this.from.year ? this.from.year : this.to.year
            },
            addRow: function (index) {
                if (this.clauses.length < this.limit) {
                    this.clauses.splice(index + 1, 0, {'bool': 'and', 'field': '', 'text': ''})
                }
            },
            removeRow: function (index) {
                this.clauses.splice(index, 1)
            },
            clear: function () {
                this.catalog = ''
                this.from = this.resetYear()
                this.to = this.resetYear()
                this.clauses = this.resetClause()
            },
            resetYear: function () {
                return {year: '', era: 'AD/CE'}
            },
            resetClause: function () {
                return [
                    {'bool': 'and', 'field': '', 'text': ''},
                    {'bool': 'and', 'field': '', 'text': ''}
                ]
            },
            search: function () {
                var stack = {'and': [], 'or': []}
                var bin = []
                var previous_bool = null

                // This is gross and there is probably a better way to do this.
                // Here we try to convert the linear and/or structure
                // to the nested and/or structure needed by elasticsearch.
                // The assumption is made that nesting should occure when
                // the boolean of the current clause differs from the previous

                // First we bin clauses into groups of ands/ors
                this.clauses.forEach(function (clause, index) {
                    // Ignore clauses that are not populated
                    if (clause.text == '' || clause.field == '') {
                        return
                    }

                    if (bin.length > 1 && previous_bool != clause.bool) {
                        stack[previous_bool].push(bin)
                        bin = []
                    }

                    bin.push(clause.field.field + '=' + clause.text)
                    previous_bool = clause.bool
                })

                // handle the last clause
                if (previous_bool != null) {
                    stack[previous_bool].push(bin)
                }

                // Second each group is joined by the opposing boolean
                // and nest under whichever boolean has greater count
                // e.g. or = [['1', '2'], ['3', '4']]; and = ['5'];
                // is the same as (1 or 2) and (3 or 4) and 5
                var bool = {}
                if (stack.and.length <= stack.or.length) {
                    bool = {'must': []}
                    stack.and.forEach(function (b) {
                        bool.must.push({'must': b})
                    })

                    stack.or.forEach(function (b) {
                        bool.must.push({'should': b})
                    })
                } else {
                    bool = {'should': []}
                    stack.and.forEach(function (b) {
                        bool.should.push({'must': b})
                    })

                    stack.or.forEach(function (b) {
                        bool.should.push({'should': b})
                    })
                }

                // Format and add date filters
                FilterManager.clearAll()
                var date_filter = this.formatDateFilter(this.from.year, this.from.era, this.to.year, this.to.era)
                if (date_filter.selected) {
                    FilterManager.filters.date.to_year = this.to.year
                    FilterManager.filters.date.from_year = this.from.year
                    FilterManager.filters.date.from_era = this.from.era
                    FilterManager.filters.date.to_era = this.to.era
                    FilterManager.addByField('date', date_filter.selected)
                }

                // Add catalog filter
                if (this.catalog) {
                    FilterManager.addByField('search_catalog', this.catalog)
                }

                // Add advanced filter
                FilterManager.filters.advanced_search.query = JSON.stringify(bool)
                FilterManager.addByField('advanced_search', 'Advanced Search')

                this.$router.push({name: 'search', query: FilterManager.generateQuery()})
            }
        }
    }
</script>

<style scoped lang="scss">
  .advanced-page {
    padding-top: 160px;

    /* apply if less than 992px (bootstrap large) */
    @media (max-width: 991px) {
      padding-top: 100px;
    }

    .select-wrapper {
      padding-bottom: 15px;

      .form-control {
        display: inline-block;
      }

      .bool-clause {
        width: 25%;
        margin-right: 10px;
      }

      .property {
        // apply if greater than 992px (bootstrap large)
        width: 38%;

        @media (min-width: 992px) {
          width: 68%;
        }
      }

      .first-property {
        // apply if greater than 992px (bootstrap large)
        width: 38%;

        @media (min-width: 992px) {
          width: 100%;
        }
      }
    }

    .search-in {
      margin-bottom: 15px;

      label {
        margin-right: 10px;
      }

      select {
        display: initial;
        width: 38%;

        @media (min-width: 992px) {
          width: 65%;
        }
      }
    }

    .alert {
      margin-bottom: 0;
    }

    .manage-clauses {
      padding-bottom: 15px;

      .form-control {
        width: 75%;
        display: inline-block;
      }

      .btn-wrapper {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
      }

      button {
        background-color: white;
        width: 26px;
        height: 26px;
        border: none;
      }
    }

    .form-buttons {
      margin-top: 20px;

      .bg-white {
        background-color: white;
      }
    }

    .add {
      margin-right: 10px;
      background-image: url('/images/add_field_icon.svg');
    }

    .remove {
      background-image: url('/images/delete_field_icon.svg');
    }

    .date-container {
      .form-control {
        display: inline-block;
      }

      .date-label {
        padding-top: 4px;
      }

      label {
        margin-right: 10px;
        width: 30px;
        text-align: right;
      }

      input {
        margin-right: 10px;
        width: 60px;
      }

      select {
        margin-right: 10px;
        width: 90px;
      }

      .to {
        padding-left: 15px;

        @media (min-width: 992px) {
          padding-left: 0;
        }
      }

      .from {
        margin-bottom: 10px;

        @media (min-width: 992px) {
          margin-bottom: 0;
        }
      }
    }
  }
</style>


